import { $, readStoredTheme, systemUsesDarkIcons, THEME_KEY, type WebTheme } from './app-state';

function syncSystemIconTheme(): void {
  const dark = document.documentElement.dataset.theme === 'dark';
  const icon = dark ? './icon-dark.svg' : './icon-light.svg';
  const fallback = $('site-favicon') as HTMLLinkElement | null;
  if (fallback) fallback.href = icon;
  const darkFavicon = $('site-favicon-dark') as HTMLLinkElement | null;
  const lightFavicon = $('site-favicon-light') as HTMLLinkElement | null;
  if (darkFavicon) darkFavicon.media = dark ? 'all' : 'not all';
  if (lightFavicon) lightFavicon.media = dark ? 'not all' : 'all';
  const darkTouch = $('apple-touch-icon-dark') as HTMLLinkElement | null;
  const lightTouch = $('apple-touch-icon-light') as HTMLLinkElement | null;
  if (darkTouch) darkTouch.media = dark ? 'all' : 'not all';
  if (lightTouch) lightTouch.media = dark ? 'not all' : 'all';
  const darkBrand = $('web-brand-dark') as HTMLSourceElement | null;
  const lightBrand = $('web-brand-light') as HTMLSourceElement | null;
  if (darkBrand) darkBrand.media = dark ? 'all' : 'not all';
  if (lightBrand) lightBrand.media = dark ? 'not all' : 'all';
  const brand = $('web-brand-icon') as HTMLImageElement | null;
  if (brand) brand.src = icon;
  const darkAboutBrand = $('site-about-brand-dark') as HTMLSourceElement | null;
  const lightAboutBrand = $('site-about-brand-light') as HTMLSourceElement | null;
  if (darkAboutBrand) darkAboutBrand.media = dark ? 'all' : 'not all';
  if (lightAboutBrand) lightAboutBrand.media = dark ? 'not all' : 'all';
  const aboutBrand = $('site-about-brand-icon') as HTMLImageElement | null;
  if (aboutBrand) aboutBrand.src = icon;
  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor) themeColor.setAttribute('content', dark ? '#0b0b0d' : '#f5f5f7');
}

function applyTheme(theme: WebTheme): void {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  const toggle = $('theme-toggle') as HTMLButtonElement;
  const next = theme === 'dark' ? '浅色' : '深色';
  toggle.title = `切换到${next}模式`;
  toggle.setAttribute('aria-label', `切换到${next}模式`);
  toggle.setAttribute('aria-pressed', String(theme === 'dark'));
  syncSystemIconTheme();
}

function saveTheme(theme: WebTheme): void {
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    // 浏览器禁用本地存储时，仍然允许本次页面切换。
  }
  applyTheme(theme);
}

function bindSystemIconTheme(): void {
  if (typeof window.matchMedia !== 'function') {
    syncSystemIconTheme();
    return;
  }
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  syncSystemIconTheme();
  const onChange = (): void => {
    if (readStoredTheme() === null) applyTheme(systemUsesDarkIcons() ? 'dark' : 'light');
    else syncSystemIconTheme();
  };
  if (typeof media.addEventListener === 'function') media.addEventListener('change', onChange);
  else media.addListener(onChange);
}

export { applyTheme, saveTheme, bindSystemIconTheme };
